import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  Chip,
} from "@mui/material";

export default function BudgetForm() {
  const theme = useTheme();
  const [formData, setFormData] = React.useState({
    projectType: "",
    name: "",
    email: "",
    phone: "",
    serviceDetails: "",
  });

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            height: "100%",
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[3],
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CardContent sx={{ p: 4, flex: 1 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{
                fontWeight: "bold",
                color: theme.palette.primary.main,
                mb: 3,
              }}
            >
              Solicite Seu Orçamento Gratuito
            </Typography>

            <Chip
              label="Orçamento 100% Gratuito"
              color="primary"
              variant="filled"
              sx={{ mb: 3 }}
            />

            <form onSubmit={handleSubmit}>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="project-type-label">
                  Um projeto de renovação ou construção?
                </InputLabel>
                <Select
                  labelId="project-type-label"
                  name="projectType"
                  value={formData.projectType}
                  onChange={handleChange}
                  label="Um projeto de renovação ou construção?"
                  required
                >
                  <MenuItem value="renovation">Renovação</MenuItem>
                  <MenuItem value="construction">Construção</MenuItem>
                  <MenuItem value="maintenance">Manutenção</MenuItem>
                  <MenuItem value="consultation">Consulta Técnica</MenuItem>
                </Select>
              </FormControl>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 3,
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  label="Seu Nome"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  variant="outlined"
                />

                <TextField
                  fullWidth
                  label="Telefone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  variant="outlined"
                />
              </Box>

              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                variant="outlined"
                sx={{ mb: 3 }}
              />

              <TextField
                fullWidth
                label="Detalhes do Serviço"
                name="serviceDetails"
                value={formData.serviceDetails}
                onChange={handleChange}
                multiline
                rows={4}
                required
                variant="outlined"
                placeholder="Descreva brevemente o serviço que você precisa..."
                sx={{ mb: 4 }}
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                sx={{
                  py: 1.2,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  backgroundColor: theme.palette.primary.main,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  transition: "all 0.3s ease-in-out",
                }}
              >
                Solicitar Orçamento
              </Button>

              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  mt: 2,
                  color: theme.palette.text.secondary,
                  fontStyle: "italic",
                }}
              >
                Entraremos em contato dentro de 24 horas para agendar sua visita
                gratuita
              </Typography>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
